export default {
    primary: {
        black: '#454547',
        white: '#fff',
        orange: '#F16521',
        orangeDark: '#E45620',
        stone: '#F4F2F1',
        darkStone: '#C3C1C3',
    },
    secondary: {
        ice: '#5FCCF5',
        lime: '#95C93D',
        midnight: '#034784',
        orangeDark: '#c7482e',
    },
    tertiary: {
        berry: '#995199',
        coffee: '#C7835E',
        pink: '#F491A4',
        red: '#DB3E3A',
        sun: '#FFD520',
        teal: '#28BAA5',
    },
    product: {
        ats: '#28BAA5',
        engagement: '#B945B9',
        marketing: '#6B9B1B',
        onboarding: '#378DB1',
        recruitment: '#B34E4B',
        referrals: '#D37184',
    },
    overlays: {
        // 16% opacity of primary.black
        black: 'rgba(69, 69, 71, 0.16)',
        // 24% opacity of primary.white
        white: 'rgba(255, 255, 255, 0.24)',
    },
    grey: {
        black: '#000',
        light: '#D2D2D3',
        lightish: '#D9d9d9',
        medium: '#595959',
        dark: '#303030',
        g100: '#D6D6D6',
        g200: '#ADADAD',
        g300: '#858585',
        g400: '#5C5C5C',
        g500: '#292929',
    },
    validation: {
        /** Hex: #28a745 */
        valid: '#28a745',
    },
};
